import { render } from "./NavItem.vue?vue&type=template&id=7869b93d"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=7869b93d&lang=css"
script.render = render

export default script